import { Button } from "react-bootstrap";

const BigButton = (props) => {
  const { className, disabled, onClick, tooltip, children } = props || {};
  return <Button
    className={className + " big"}
    disabled={disabled}
    onClick={onClick}
  >
    <div className="fs-4">{children}</div>
    <div className="small">{tooltip}</div>
  </Button>
}

export default BigButton;
